import { State } from '../hooks/useAppState'
import { Organization } from '../ygdrasil/types/types'

export function shouldManangeSubscription(org: Organization | undefined, state: State) {
  if (!org?.subscription) return true
  return org?.subscription?.metadata.obpUserId === state.user._id
}
